<template>
  <ul class="contacto flex-col-nowrap max-w-full">
    <li class="mapa">
      <a 
        href="https://goo.gl/maps/BkGVNshX68nMprLQ8"
        target="blank"
        class=" link hover:underline"
      >
        <div 
          class="datos-contacto max-w-full flex flex-col sm:flex-row text-blue  items-center"
          :class="mode"
        >

          <base-icon
            icon-name="map"
            :icon-border="colorIconos"
            view-box="5 1.5 24 29.7"
            class="inline-block w-fit"
            width="100%"
            height="100%"
          >
            <icon-map />
          </base-icon>
          <p class="text-azul  inline-block text-center pl-4  pt-4">
            Marcial Candioti 2951 - Vecinal Candioti Sur
          </p>
        </div>
      </a>
    </li>
    <li class="mail">
      <!-- hacer que los colores de los íconos sean editables -->
      <a
        href="mailto:abriendoeljuegosf@gmail.com"
        class="link hover:underline"
      >
        <div 
          class="datos-contacto max-w-full flex flex-col sm:flex-row text-blue items-center"
          :class="mode"
        >
          <base-icon
            icon-name="mail"
            :icon-border="colorIconos"
            view-box="2 1.5 27 29.7"
            class="inline-block w-fit"
            width="100%"
            height="100%"
          >
            <icon-mail />
          </base-icon>
          <p class="text-azul  inline-block pl-4 pt-4">abriendoeljuegosf@gmail.com</p>
        </div>
      </a>
    </li>
  </ul>
</template>

<script>
export default {
    props: {
        mode: {
            type: String,
            requiered: false,
            default: "justify-start"
        },
        colorIconos: {
            type: String,
            requiered: false,
            default: "black"
        }
    },
    data() {
      return {
        
      }
    },
    computed: {
      isMovil() {
        console.log('isMovil = ' + this.$store.getters.getMovilView)
        return this.$store.getters.getMovilView;
      },
    }
};
</script>

<style scoped>
  .link:hover {
    text-decoration-color: blue;
  }

  .contacto .mail, .contacto .mapa {
    margin-bottom: 6rem;
  }

  .datos-contacto p {
    font-size: 2.4rem;    
    line-height: 3rem;
    width: 34rem;
    max-width: 100%;
    padding-left: 0;
  }

  .datos-contacto svg {
    width: 4rem;
  }

  /* footer .mapa , footer .mail {
    --iconBorderColor: brown
  } */


  @media screen and (max-width: 380px) {
  .datos-contacto p {
    font-size: 6vw;   
    text-align: center; 
  }

  .contacto .mail, .contacto .mapa {
    margin-bottom: 1rem;
  }


}

  @media screen and (min-width: 640px) {
    .contacto .mail, .contacto .mapa {
      margin-bottom: 0.8rem;
    }

    .datos-contacto {
      padding: 0rem;
    }

    .datos-contacto p {
    padding: 0rem;
    padding-left: 1.5rem;
    width: fit-content;
    font-size: 2.0rem;    
    line-height: 3rem;
    max-width: 100%;
  }

  .datos-contacto svg {
    width: 3rem;
  }

  
  footer .datos-contacto svg {
    width: 2.5rem;
  }

  footer .datos-contacto p {
    width: fit-content;
    font-size: 1.5rem;    
    line-height: 2rem;
  }
}
</style>